<template>
  <div id="news">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/news/header-img.png" />
      <div class="header-title">News & Events</div>
    </div>
    <!-- Call for Applicaiton -->
    <el-dialog title="Call for Applicaiton" :visible.sync="dialogVisibleCall" width="65%">
      <el-form class="demo-form-inline">
        <el-form-item>
          <div>
            {{ this.call4App }}
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="sub_btn_form" type="primary" @click="dialogVisibleCall = false"
            >I know</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- Join弹窗 -->
    <el-dialog title="Join" :visible.sync="dialogVisible" width="65%" :before-close="handleClose">
      <el-form :rules="rules" :model="joinForm" class="demo-form-inline" ref="joinForm">
        <el-form-item
          v-for="(item, index) in eventInputList"
          :key="index"
          :label="item + ':'"
          :prop="item.toLowerCase().replace('-', '').replace(' ', '')"
        >
          <el-input
            v-model="joinForm[item.toLowerCase().replace('-', '').replace(' ', '')]"
            placeholder=""
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="sub_btn_form" type="primary" @click="submitForm('joinForm')"
            >Submit</el-button
          >
        </el-form-item>
      </el-form>
      <!-- <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="News" name="News"></el-tab-pane>
      <el-tab-pane label="Events" name="Events"></el-tab-pane>
    </el-tabs>
    <div class="page-content" v-if="activeName === 'News'">
      <div class="content-text">
        <div class="title">
          {{ activeName }}
          <div class="total">Total：{{ listQuery.total }}</div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Key words">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Release time">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Resource">
            <el-input v-model="formInline.resource" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-link type="primary">Search</el-link>
          </el-form-item>

          <div
            class="publish"
            @click="navigateTo('/login', 'news')"
            v-if="this.$store.state.webType !== 'h5'"
          >
            Publish News
          </div>
        </el-form>
      </div>
      <el-row :gutter="24" class="news-list">
        <el-col :span="6" v-for="(item, index) in list" :key="index">
          <div class="list-item" @click="$goDetail(item.aId, 'news')">
            <div class="img-view" v-if="item.coverImage">
              <img class="item-img" :src="item.coverImage" />
            </div>
            <div class="item-title">
              {{ item.title }}
            </div>
            <div class="item-date">{{ item.time }}</div>
          </div>
        </el-col>
      </el-row>

      <div class="more-text" v-if="list.length < listQuery.total" @click="handleListMore">
        View More
      </div>
    </div>
    <div class="page-content evens" v-else>
      <div class="content-text">
        <div class="title">
          {{ activeName }}
          <div class="total">Total：{{ listQuery.total }}</div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Key words">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Release time">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Resource">
            <el-input v-model="formInline.resource" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-link type="primary">Search</el-link>
          </el-form-item>

          <div
            class="publish"
            @click="navigateTo('/login', 'events')"
            v-if="this.$store.state.webType !== 'h5'"
          >
            Publish Events
          </div>
        </el-form>
      </div>

      <el-row :gutter="24" class="news-list">
        <el-col :span="24" v-for="(item, index) in list" :key="index">
          <div class="list-item" v-if="item.coverImage">
            <div class="img-view" v-if="item.coverImage">
              <img class="item-img" :src="item.coverImage" />
            </div>
            <div class="item-info">
              <div class="item-title" @click="$goDetail(item.aId, 'events')">
                {{ item.title }}
              </div>
              <div class="data-view">
                <div class="item-date">
                  <div class="label">Time：</div>
                  <!-- <div class="text">{{ item.time | formatDate }}</div> -->
                  <div class="text">{{ item.time }}</div>
                </div>
                <div class="item-date" v-if="item.deadLine">
                  <div class="label">Dead Line：</div>
                  <!-- <div class="text">{{ item.deadLine | formatDate }}</div> -->
                  <div class="text">{{ item.deadLine }}</div>
                </div>
                <div class="item-date">
                  <div class="label">Location：</div>
                  <div class="text">{{ item.location }}</div>
                </div>
                <div class="item-date">
                  <div class="label">Initiator：</div>
                  <div class="text">France俱乐部</div>
                </div>
              </div>
              <div class="item-content" v-html="item.brief"></div>
              <div class="btn-view">
                <div class="item-btn" @click="goCall4App(item.application)">
                  Apply Now
                </div>
                <div
                  class="item-btn"
                  v-if="'Yes' === item.isActivity"
                  @click="goJoin(item.aId, item.activityInformation)"
                >
                  Join
                </div>
                <div class="item-btn" @click="$goDetail(item.aId, 'events')">
                  Read more <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="list-item" v-else>
            <div class="img-view" v-if="item.coverImage">
              <!-- <img class="item-img" :src="item.coverImage" /> -->
            </div>
            <div class="item-info">
              <div class="item-title" @click="$goDetail(item.aId, 'events')">
                {{ item.title }}
              </div>
              <div class="data-view">
                <div class="item-date">
                  <div class="label">Time：</div>
                  <!-- <div class="text">{{ item.time | formatDate }}</div> -->
                  <div class="text">{{ item.time }}</div>
                </div>
                <div class="item-date" v-if="item.deadLine">
                  <div class="label">Dead Line：</div>
                  <!-- <div class="text">{{ item.deadLine | formatDate }}</div> -->
                  <div class="text">{{ item.deadLine }}</div>
                </div>
                <div class="item-date">
                  <div class="label">Location：</div>
                  <div class="text">{{ item.location }}</div>
                </div>
                <div class="item-date">
                  <div class="label">Initiator：</div>
                  <div class="text">France俱乐部</div>
                </div>
              </div>
              <div class="item-content" :title="item.title" v-html="item.brief"></div>
              <div class="btn-view2">
                <div class="item-btn" v-if="item.application" @click="goCall4App(item.application)">
                  Call for Applicaion
                </div>
                <div style="width: 195px" v-if="currentViewType !== 'h5'"></div>
                <div
                  class="item-btn"
                  v-if="'Yes' === item.isActivity"
                  @click="goJoin(item.aId, item.activityInformation)"
                >
                  Join
                </div>
                <div
                  v-if="currentViewType !== 'h5'"
                  class="item-btn"
                  @click="$goDetail(item.aId, 'events')"
                >
                  Read more <i class="el-icon-right"></i>
                </div>
                <div
                  v-else
                  class="item-btn"
                  @click="$goDetail(item.aId, 'events')"
                  style="margin-left: -10px"
                >
                  Read more <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="more-text" v-if="list.length < listQuery.total" @click="handleListMore">
        View More
      </div>
    </div>
  </div>
</template>

<script>
import goTop from "../components/goTop";
import HotArticle from "@/components/HotArticle";
import NewBook from "@/components/NewBook";

export default {
  name: "CharacterStory",
  components: {
    goTop,
    HotArticle,
    NewBook,
  },
  data() {
    return {
      call4App: null,
      //eventInputList : ['Name','Gender','Country','E-mail','Contact Number','ORG-name'],
      eventInputList: [],
      dialogVisible: false,
      dialogVisibleCall: false,
      activeName: "News",
      formInline: {},
      // 文章列表
      list: [],
      maxPage: 1,
      // 文章列表请求信息
      listQuery: {
        pageSize: 8,
        pageNum: 1,
        type: 1,
        total: 0, // 文章总数量
      },
      joinForm: {
        aId: null,
        name: null,
        gender: null,
        country: null,
        email: null,
        contactnumber: null,
        orgname: null,
      },
      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }],
        gender: [{ required: true, message: "Please input gender", trigger: "blur" }],
        country: [{ required: true, message: "Please input country", trigger: "blur" }],
        email: [{ required: true, message: "Please input E-mail", trigger: "blur" }],
        contactnumber: [
          { required: true, message: "Please input Contact Number", trigger: "blur" },
        ],
        orgname: [{ required: true, message: "Please input ORG-name", trigger: "blur" }],
      },
      currentViewType: "",
    };
  },
  mounted() {
    // if (this.$route.query.token) {
    //   sessionStorage.setItem("token", this.$route.query.token);
    // }
    // this.listQuery.columnId = this.$getPartId(this.$route.path);
    // this.listQuery.menuId = this.$getMenuId(this.$route.path);
    if (this.$route.path.indexOf("news") > -1) {
      this.listQuery.type = 1;
    } else {
      this.listQuery.type = 2;
    }
    if (this.$route.query && this.$route.query.type === "Events") {
      this.activeName = "Events";
      this.listQuery.type = 2;
    } else {
      this.listQuery.type = 1;
      this.activeName = "News";
    }
    this.getList();
    if (window.innerWidth < 500) {
      this.currentViewType = "h5";
    } else {
      this.currentViewType = "";
    }
  },
  methods: {
    goJoin(aId, acts) {
      this.dialogVisible = true;
      this.eventInputList = acts;
      this.joinForm.aId = aId;
    },
    goCall4App(msg) {
      this.dialogVisibleCall = true;
      this.call4App = msg;
    },
    submitForm(formName) {
      let data = {
        aId: this.joinForm.aId,
        name: this.joinForm.name,
        gender: this.joinForm.gender,
        country: this.joinForm.country,
        email: this.joinForm.email,
        phone: this.joinForm.contactnumber,
        orgName: this.joinForm.orgname,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = "/un/webrelease/mail";
          this.$post(this.$api + url, data).then((res) => {
            this.$message({
              message:
                this.$store.state.lang == "FR" ? "Soumettre avec succès!" : "Submit Success！",
              type: "success",
            });
            this.$refs[formName].resetFields();
            this.dialogVisible = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose(done) {
      this.dialogVisible = false;
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    goPublishEvent() {
      this.$router.push("/login");
    },
    navigateTo(route, para) {
      this.$router.push({ path: route, query: { q: para } });
      //this.$router.push(route);
    },
    async getNewsTags() {
      this.$get(this.$api + "/un/weblable/dicttypenews").then((res) => {
        this.newsTagsList = res.data;
      });
    },
    async loadMore() {
      // console.log(
      //   "loadMore",
      //   this.busy || this.listQuery.pageNum >= this.maxPage
      // );
      if (this.busy || this.listQuery.pageNum >= this.maxPage) return;
      this.busy = true;
      this.listQuery.pageNum += 1;
      await this.getList();
    },
    handleListMore() {
      this.listQuery.pageNum += 1;
      this.getList();
    },
    handleClick(val) {
      if (this.activeName !== val) {
        this.listQuery = {
          pageSize: 8,
          pageNum: 1,
          type: val === "News" ? 1 : 2,
          total: 0, // 文章总数量
        };
        this.list = [];
        this.formInline = {};
        this.getList();
      }
    },
    async getList() {
      this.$get(this.$api + "/un/webarticle/list", {
        ...this.listQuery,
        ...this.formInline,
      }).then((res) => {
        this.list = [...this.list, ...res.data];
        this.listQuery.total = res.total;
        this.maxPage = res.maxPage;

        let that = this;
        this.$nextTick(() => {
          that.nomore = true;
          setTimeout(() => {
            that.busy = false;
          }, 300);
        });
      });
    },
  },
};
</script>
<style>
/***.en #news .banner-view .content-html p,
.en #news .banner-view .content-html article {
  font-family: "Times New Roman", Times, serif !important;
} ***/
</style>
<style lang="scss" scoped>
.mobile {
  .title {
    font-size: 20px !important;
    line-height: 20px !important;
    .text {
      font-size: 14px !important;
      margin: 14px 0 !important;
      line-height: 22px !important;
    }
  }
  #news .page-content.evens .news-list .list-item .item-info .btn-view2 {
    margin-left: 47%;
  }
  #news .page-content.evens .news-list .list-item .item-info .btn-view2 .item-btn {
    // width: max-content !important;
    // padding: fh(9vh, pc) fw(180vw, pc);
    width: 174px !important;
    text-align: center;
  }
  #news {
    .page-header {
      padding-top: 50px !important;
    }
    .page-content {
      padding: 20px 10px !important;
      .more-text {
        font-size: 16px !important;
        line-height: 20px !important;
        margin: 20px auto !important;
      }
      .news-list {
        .list-item {
          flex-wrap: wrap;
          height: max-content !important;
          .img-view {
            width: 100% !important;
            height: max-content !important;
          }
          .item-info {
            .item-title {
              margin-bottom: 10px !important;
              font-size: 20px !important;
              line-height: 26px !important;
            }
            .item-content {
              min-height: auto !important;
              height: max-content !important;
              margin-bottom: 30px !important;
            }
            .btn-view {
              position: static !important;
              bottom: 0px !important;
              flex-wrap: wrap;
              .item-btn {
                margin-top: 10px !important;
                width: 174px !important;
                text-align: center;
              }
            }
            .data-view {
              flex-wrap: wrap;
              .item-date {
                width: 100% !important;
                .text {
                  margin-bottom: 5px !important;
                }
              }
            }
          }
        }
        .el-col {
          width: 100% !important;
        }
      }
      ::v-deep .el-form {
        width: 100%;
        padding: 20px 10px !important;
        .el-link--inner {
          width: 50vw;
          background-color: #00a0e1;
          padding: 2px 0 !important;
          color: #fff;
          border-radius: 30px !important;
          text-align: center;
          margin-left: 25vw !important;
        }
        .el-link.el-link--primary:hover::after {
          display: none !important;
        }
        .el-form-item {
          width: 100%;
          .el-form-item__label {
            width: 100px !important;
            text-align: left;
          }
          .el-form-item__content {
            margin-left: auto;
            width: calc(100% - 100px) !important;
          }
          .el-input__inner {
            width: 100% !important;
          }
        }
      }
    }
  }
}
#news {
  position: relative;
  width: 100%;
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      // padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
  .page-content {
    padding: fh(60vh, pc) fw(200vw, pc);
    .more-text {
      margin: 0 auto;
      font-size: fh(18vh, pc);
      color: #0077d4;
      width: max-content;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &.evens {
      .news-list {
        padding-top: fh(20vh, pc);
        .list-item {
          display: flex;
          .img-view {
            width: fw(490vw, pc);
            height: fh(345vh, pc);
          }
          .item-info {
            position: relative;
            padding-left: fw(20vw, pc);
            flex: 1;
            .btn-view {
              position: absolute;
              bottom: fh(20vh, pc);
              right: 0;
              display: flex;
              // width: 100%;
              align-items: flex-end;
              .item-btn {
                padding: fh(9vh, pc) fw(40vw, pc);
                font-size: fh(18vh, pc);
                line-height: fh(22vh, pc);
                color: #0077d4;
                border: 1px solid #ececec;
                border-radius: fh(20vh, pc);
                &:nth-child(2) {
                  margin-left: fw(20vw, pc);
                  margin-right: auto;
                }
                &:hover {
                  background-color: #0077d4;
                  color: #fff;
                  cursor: pointer;
                  border-color: #0077d4;
                }
                &:nth-child(3) {
                  background-color: #0077d4;
                  color: #fff;
                  &:hover {
                    cursor: pointer;
                    opacity: 0.8;
                  }
                }
              }
            }
            .btn-view2 {
              display: flex;
              align-items: flex-end;
              margin-top: 10px;
              margin-left: 69%;
              .item-btn {
                padding: fh(9vh, pc) fw(40vw, pc);
                font-size: fh(18vh, pc);
                line-height: fh(22vh, pc);
                color: #0077d4;
                border: 1px solid #ececec;
                border-radius: fh(20vh, pc);
                WIDTH &:nth-child(2) {
                  margin-left: fw(20vw, pc);
                  margin-right: auto;
                }
                &:hover {
                  background-color: #0077d4;
                  color: #fff;
                  cursor: pointer;
                  border-color: #0077d4;
                }
                &:nth-child(3) {
                  background-color: #0077d4;
                  color: #fff;
                  &:hover {
                    cursor: pointer;
                    opacity: 0.8;
                  }
                }
              }
            }
            .item-title {
              margin-bottom: fh(40vh, pc);
            }
            .data-view {
              width: 100%;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              .item-date {
                font-size: fh(15vh, pc);
                display: flex;
                overflow: hidden;
                margin-right: 20px;
                .text {
                  color: #333;
                }
              }
            }
            .item-content {
              margin-top: fh(40vh, pc);
              font-size: fh(18vh, pc);
              line-height: fh(28vh, pc);
              color: #333;
              max-height: 114px;
              overflow: hidden;
              min-height: fh(112vh, pc);
              margin-bottom: fh(28vh, pc);
              display: -webkit-box; /* 使用弹性盒模型布局 */
              -webkit-line-clamp: 4; /*显示的行数*/
              -webkit-box-orient: vertical; /* 垂直方向排列*/
              overflow: hidden;
              text-overflow: ellipsis; /* 超出部分显示省略号*/
            }
          }
        }
      }
    }

    .news-list {
      display: flex;
      flex-wrap: wrap;
      .list-item {
        padding-top: fh(20vh, pc);
        margin-bottom: fh(50vh, pc);
        margin-bottom: fh(20vh, pc);
        border-top: 1px solid #e4e4e4;
        overflow: hidden;
        .img-view {
          position: relative;
          width: 100%;
          height: fh(260vh, pc);
          // height: fh(222vh, pc);
          overflow: hidden;
          margin-bottom: fh(20vh, pc);
          img {
            position: relative;
            display: block;
            width: 100%;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .item-date {
          font-size: fh(18vh, pc);
          line-height: fh(22vh, pc);
          color: #999;
        }
        .item-title {
          margin-bottom: fh(20vh, pc);
          font-size: fh(24vh, pc);
          line-height: fh(29vh, pc);
          color: #333;
          font-weight: bold;
          display: -webkit-box; /* 使用弹性盒模型布局 */
          -webkit-line-clamp: 4; /*显示的行数*/
          -webkit-box-orient: vertical; /* 垂直方向排列*/
          overflow: hidden;
          text-overflow: ellipsis; /* 超出部分显示省略号*/
          &:hover {
            cursor: pointer;
            color: #000;
          }
        }
      }
    }
    .content-text {
      .publish {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        color: #005db3;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          opacity: 0.8;
        }
      }
      .title {
        font-size: fh(36vh, pc);
        line-height: fh(54vh, pc);
        color: #333;
        font-weight: bold;
        .total {
          font-size: fh(16vh, pc);
          line-height: fh(24vh, pc);
          color: #787878;
          margin-left: fw(60vw, pc);
          display: inline-block;
        }
      }
      .text {
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        color: #2a2a2a;
      }
    }
    ::v-deep .el-form {
      padding-top: fh(46vh, pc);
      padding-bottom: fh(40vh, pc);
      position: relative;
      .el-form-item {
        margin-right: fw(20vw, pc);
        .el-input__inner {
          width: fw(288vw, pc);
          border-radius: 50px;
        }
      }
      .el-link {
        font-size: fh(18vh, pc);
        color: #005db0;
      }
    }
  }
}
</style>
